var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 36,
    viewBox: "0 0 146 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.106%",
    y1: "100.523%",
    x2: "50.106%",
    y2: ".003%",
    id: "cat4fh6zaa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6512%",
    y1: "5251%",
    x2: "6512%",
    y2: "2735%",
    id: "cu6k5nzurb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606064",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.075 6.941a2.02 2.02 0 0 0-2.774.52c-.611.92-.383 2.167.512 2.804 4.228 2.937 6.087 8.32 4.588 13.292-1.499 4.972-6.007 8.38-11.13 8.415-5.124.034-9.677-3.312-11.24-8.264-1.564-4.95.223-10.359 4.412-13.353a2.046 2.046 0 0 0 .457-2.849 2.02 2.02 0 0 0-2.785-.486c-5.615 4.006-8.016 11.246-5.932 17.881C58.268 31.536 64.356 36.031 71.22 36c6.863-.03 12.913-4.578 14.94-11.231 2.028-6.653-.436-13.872-6.084-17.828z",
    fill: "url(#cat4fh6zaa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.602 3.47c2.238 1.163 3.623 3.521 3.565 6.072v15.985c-.01.303.035.606.134.893.237.533.566 1.019.97 1.436.196.287.483.498.813.599.334-.099.625-.31.824-.6.402-.41.73-.888.97-1.412.098-.287.144-.59.133-.893V9.542c-.066-2.54 1.3-4.897 3.52-6.071 1.249-.61 1.427-1.063 1.472-1.47.044-.407.055-.848.055-1.13a.718.718 0 0 0-.21-.52.696.696 0 0 0-.514-.204c-.379 0-2.028-.136-3.743-.147h-5.048c-1.715 0-3.342.124-3.743.147a.696.696 0 0 0-.515.204.718.718 0 0 0-.21.52c0 .27 0 .712.056 1.13.056.418.223.86 1.471 1.47z",
    fill: "url(#cu6k5nzurb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#606064",
    d: "M5.716 14.945H0V11.08h15.598v3.866H9.86v15.172H5.716zM18.885 11.079H33.08v3.73H23.052v3.867h8.913v3.73h-8.913v4.003h10.206v3.708H18.885zM36.879 11.079h14.183v3.73H41.035v3.867h8.913v3.73h-8.913v4.003H51.24v3.708H36.88zM91.016 20.654c.458-5.25 4.793-9.278 9.989-9.278 5.195 0 9.53 4.027 9.988 9.278-.458 5.252-4.793 9.279-9.988 9.279-5.196 0-9.531-4.027-9.989-9.279zm15.654 0a5.847 5.847 0 0 0-1.598-4.217 5.676 5.676 0 0 0-4.095-1.774 5.531 5.531 0 0 0-4.085 1.73 5.7 5.7 0 0 0-1.553 4.205 5.847 5.847 0 0 0 1.602 4.222 5.676 5.676 0 0 0 4.102 1.77 5.533 5.533 0 0 0 4.042-1.755 5.7 5.7 0 0 0 1.53-4.18h.055zM114.101 11.056h14.317v3.81h-10.183v4.059h8.97v3.82h-8.97v7.372h-4.134zM131.683 11.056H146v3.81h-10.183v4.059h8.969v3.82h-8.97v7.372h-4.133z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeOff);
export default __webpack_public_path__ + "static/media/tee-off.3f6a768dbd208d4b0f0826f370c3aa98.svg";
export { ForwardRef as ReactComponent };